import React, { useState, useEffect } from 'react'
import db from '../firebase/config'
import FacebookIcon from '@material-ui/icons/Facebook'
import GitHubIcon from '@material-ui/icons/GitHub'
import TelegramIcon from '@material-ui/icons/Telegram'
import LinkedInIcon from '@material-ui/icons/LinkedIn'
import Reveal from 'react-reveal/Reveal'
import { Link } from 'react-router-dom'

const AboutInfo = () => {

    const [portfolios, setPortfolios] = useState([]);

    useEffect(() => {
        db.collection("portfolio").onSnapshot((snapshot) =>
            setPortfolios(snapshot.docs.map((doc) => doc.data())))
    }, [])

    return (
        <div className="aboutinfo">
            {portfolios.map(portfolio => (
                <>
                    <div className="side2">
                        <img className="myImage" src={portfolio.images} alt="my images" />
                    </div>
                    <div className="side1">
                        <Reveal effect="fadeinUp" duration="3250">
                            <h1 className="title">{portfolio.title}</h1>
                            <p className="desc">{portfolio.description}</p>
                        </Reveal>
                        <div className="buttons">
                            <Link to="/about" className="linkbtn">
                                About us
                            </Link>
                            <Link to="/portfolio" className="linkbtn">
                                Portfolio
                            </Link>
                        </div>
                        <div className="socialNet">
                            <a className="links" href="https://www.facebook.com/iftixor.turamuradov" target="_blank">
                                <FacebookIcon className="iconSVG" />
                            </a>
                            <a className="links" href="https://github.com/IftixorT" target="_blank">
                                <GitHubIcon className="iconSVG" />
                            </a>
                            <a className="links" href="https://t.me/@Iftixor_Dev" target="_blank">
                                <TelegramIcon className="iconSVG" />
                            </a>
                            <a className="links" href="https://www.linkedin.com/in/iftixor-turamuradov-89960320a/" target="_blank">
                                <LinkedInIcon className="iconSVG" />
                            </a>
                        </div>
                    </div>
                </>
            ))}

        </div>
    )
}

export default AboutInfo
